import type { ExperienceItem, TrackExperienceMetadata } from '@/types/abtest'
import { pushToDataLayer } from '@/utils/gtm'

export function hasExperience(experiences: ExperienceItem[], experienceKey: string, key: string): boolean {
  if (!experiences || !Array.isArray(experiences) || experiences.length === 0) {
    return false
  }

  if (!experienceKey || typeof experienceKey !== 'string' || experienceKey.trim() === '') {
    return false
  }

  if (!key || typeof key !== 'string' || key.trim() === '') {
    return false
  }

  return experiences.some((experience) => {
    if (!experience || typeof experience !== 'object' || !experience.experienceKey || !experience.key) {
      return false
    }

    return experience.experienceKey === experienceKey && experience.key === key
  })
}

export function pushConvertExperimentsToDataLayer(
  experiences: ExperienceItem[],
  visitorId: string,
  userId?: number | null,
  memberId?: string | number | null
): void {
  if (!experiences || !Array.isArray(experiences) || experiences.length === 0) {
    return
  }

  experiences.forEach((experience) => {
    if (
      experience &&
      typeof experience === 'object' &&
      experience.experienceId &&
      experience.experienceKey &&
      experience.id &&
      experience.key
    ) {
      pushToDataLayer({
        event: 'convertExperiment',
        experienceId: experience.experienceId,
        experienceKey: experience.experienceKey,
        id: experience.id,
        key: experience.key,
        visitorId,
        userId: userId ?? null,
        memberId: memberId ?? null
      })
    }
  })
}

export function pushConvertActionToDatalayer(
  interaction: string,
  experience: ExperienceItem,
  visitorId: string,
  userId?: number | null,
  metadata?: TrackExperienceMetadata
): void {
  if (!interaction || typeof interaction !== 'string' || interaction.trim() === '') {
    return
  }

  if (!experience || typeof experience !== 'object') {
    return
  }

  if (
    !experience.experienceId ||
    !experience.experienceKey ||
    !experience.id ||
    !experience.key
  ) {
    return
  }

  pushToDataLayer({
    event: 'convertExperimentInteraction',
    interaction,
    userId: userId ?? null,
    memberId: metadata?.memberId ?? null,
    experienceId: experience.experienceId,
    experienceKey: experience.experienceKey,
    id: experience.id,
    key: experience.key,
    visitorId,
    ...(metadata?.membershipType ? { membershipType: metadata.membershipType } : {})
  })
}
